import { render, staticRenderFns } from "./Yellowslip.vue?vue&type=template&id=252355c7&scoped=true&"
import script from "./Yellowslip.vue?vue&type=script&lang=js&"
export * from "./Yellowslip.vue?vue&type=script&lang=js&"
import style0 from "./Yellowslip.vue?vue&type=style&index=0&id=252355c7&prod&scoped=true&lang=css&"
import style1 from "./Yellowslip.vue?vue&type=style&index=1&id=252355c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252355c7",
  null
  
)

export default component.exports